import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import SectionTitle from '../../_common/SectionTitle';
import Creator from './Creator';
import Offer from '../Offer';
import AlertWarning from '../../_common/AlertWarning';
import AlertSuccess from '../../_common/AlertSuccess';
import useMissingFields from '../useMissingFields';
import Loader from '../../../components/Loader';

export default function Layout(props) {
  const { offer } = props;

  const { missingFields } = useMissingFields(offer);

  if (missingFields.state === PayloadStates.FETCHING) {
    return (
      <div className="h-screenx">
        <Loader />
      </div>
    );
  }

  return (
    <div className="page space-y-12">
      <div className="flex space-x-8">
        <div className="flex-1 space-y-12">
          {missingFields.data.length > 0 ? (
            <AlertWarning
              title="Offer description is not being shared publicly because key information is missing!"
              subtitle={(
                <>
                  Required fields are highlighted below. You can support the partner by having them
                  complete required fields with their current thinking - they can always update if the
                  offer evolves. Educators need this information to decide if they'd like to work
                  with the partner.
                </>
              )}
            >
              <Creator offer={offer} />
            </AlertWarning>
          ) : (
            <AlertSuccess
              title="Offer has been described"
              subtitle="No required fields are missing."
            />
          )}
          <Offer offer={offer} />
        </div>
      </div>
    </div>
  );
};
